import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faGithub,
  faTwitter,
  faLinkedin,
  faYoutube
} from '@fortawesome/free-brands-svg-icons';
import { useTheme } from '../../context/ThemeContext';
import { useLocation } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const { theme } = useTheme();
  const location = useLocation();
  const currentYear = new Date().getFullYear();
  const isHomePage = location.pathname === '/';

  if (!isHomePage) {
    return (
      <footer className={`${theme === 'light' ? 'light-footer light-footer-simple' : 'dark-footer dark-footer-simple'} py-3 mt-4`}>
        <Container>
          <div className="text-center">
            <p className="mb-0">&copy; {currentYear} DataPylot. All rights reserved. <br className="d-block d-sm-none" />Designed and Developed by <a href="https://www.ctronicsinfotech.in" target="_blank" rel="noopener noreferrer" className="footer-link">Ctronics InfoTech</a></p>
          </div>
        </Container>
      </footer>
    );
  }

  return (
    <footer className={`${theme === 'light' ? 'light-footer' : 'dark-footer'} py-5 mt-auto`}>
      <Container>
        <Row className="align-items-center">
          {/* Quick Links - Left */}
          <Col md={4} className="mb-4 mb-md-0">
            <h5 className="footer-heading">Quick Links</h5>
              <Col xs={12}>
                <ul className="list-unstyled footer-links">
                  <li className="mb-2"><a href="/" className="footer-link">Home</a></li>
                  <li className="mb-2"><a href="/courses" className="footer-link">Courses</a></li>
                  <li className="mb-2"><a href="/my-dashboard" className="footer-link">My Dashboard</a></li>
                </ul>
              </Col>
          </Col>

          {/* DataPylot Logo - Center */}
          <Col md={4} className="text-center mb-4 mb-md-0">
            <div className="d-flex flex-column align-items-center footer-brand">
              <img
                src="/logo.png"
                width="80"
                height="80"
                alt="DataPylot Logo"
                className="footer-logo mb-3"
              />
              <h5 className="mb-2 brand-name-footer">DataPylot</h5>
              <p className="text-secondary mb-3" style={{ fontSize: '0.95rem' }}>
                An Initiative of Ctronics Infotech
              </p>
              <div className="social-links">
                <a href="https://github.com" target="_blank" rel="noopener noreferrer" className="social-icon">
                  <FontAwesomeIcon icon={faGithub} size="lg" />
                </a>
                <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="social-icon">
                  <FontAwesomeIcon icon={faTwitter} size="lg" />
                </a>
                <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="social-icon">
                  <FontAwesomeIcon icon={faLinkedin} size="lg" />
                </a>
                <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="social-icon">
                  <FontAwesomeIcon icon={faYoutube} size="lg" />
                </a>
              </div>
            </div>
          </Col>

          {/* Contact Us - Right */}
          <Col md={4} className="text-md-end">
            <h5 className="footer-heading">Contact Us</h5>
            <address className="footer-address">
              <p className="mb-1">Phone: +91 9823540321 | +91 9356409884</p>
              <p className="mb-1">+91 9359653916 | +91 8421298578</p>
              <p className="mb-1">Ctronics Infotech Pvt. Ltd.</p>
              <p className="mb-0">Swanand, Ganesh Colony<br />Amravati 444605, MH, India</p>
            </address>
          </Col>
        </Row>

        <hr className="footer-divider my-4" />

        <div className="text-center footer-copyright">
          <p className="mb-0">&copy; {currentYear} DataPylot. All rights reserved. <br className="d-block d-sm-none" />Designed and Developed by <a href="https://www.ctronicsinfotech.in" target="_blank" rel="noopener noreferrer" className="footer-link">Ctronics InfoTech</a></p>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
